import axios, { AxiosRequestConfig } from 'axios';
import { normalizeAxiosError } from './errors';

export async function publicGet<T>(
    url: string,
    config?: AxiosRequestConfig
): Promise<T> {
    try {
        const response = await axios.get<T>(url, config);
        return response.data;
    } catch (error) {
        throw normalizeAxiosError(error);
    }
}
